"use client"
import React from 'react';
import {license} from "@/constants/static-data";
import Image from "next/image";

function LicenceComponent() {
    return (
        <div
            className="w-full flex flex-wrap gap-3 justify-center items-center md:justify-start mb-5 md:mt-10 md:order-2">
            {license.map((item: any, index: number) => (
                <React.Fragment key={index}>

                    {item?.type === "enamad" && (
                        <>
                            <a
                                referrerPolicy="origin"
                                target="_blank"
                                href="https://trustseal.enamad.ir/?id=460174&Code=OCZG5Uzg1t6DrdMt5k0hMqWMtIIQt8rf"
                            >
                                <Image
                                    height={120}
                                    width={120}
                                    className="w-[120px] h-[120px] border flex items-center justify-center rounded-xl"
                                    referrerPolicy="origin"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=460174&Code=OCZG5Uzg1t6DrdMt5k0hMqWMtIIQt8rf"
                                    alt="اینماد- فروشگاه اینترنتی الانزا"
                                    title="اینماد- فروشگاه اینترنتی الانزا"
                                />
                            </a>
                        </>
                    )}
                    {item?.type === "samandehi" && (
                        <>
                            <Image
                                height={120}
                                width={120}
                                className="w-[120px] h-[120px] border flex items-center justify-center rounded-xl"
                                onClick={() =>
                                    window.open(
                                        "https://logo.samandehi.ir/Verify.aspx?id=171625&p=rfthjyoerfthgvkauiwkdshw",
                                        "Popup",
                                        "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                                    )
                                }
                                alt="ساماندهی- فروشگاه اینترنتی الانزا"
                                title="ساماندهی- فروشگاه اینترنتی الانزا"
                                loading="lazy"
                                src="https://logo.samandehi.ir/logo.aspx?id=171625&p=nbpdyndtnbpdwlbqodrfujyn"
                            />
                        </>
                    )}
                </React.Fragment>
            ))}
        </div>

    );
}

export default LicenceComponent;